import debug from 'debug';
import { camelCaseToDashCase, dashCaseToCamelCase } from 'Global/Shared/Components/Utils/Case';
import Behaviour from './behaviour';
import Templates from './templates';

const log = debug('Overlay:Modal');

class Modal {
	/**
	 * @param {string} instanceId overlay instande id
	 */
	constructor(instanceId) {
		this.instanceId = instanceId;
		this.closeEvent = this.closeHandler.bind(this);
	}

	closeHandler(event) {
		event.preventDefault();
		log('closeHandler()');
		Behaviour.dispatchEvent(Behaviour.eventKeys.modalClose, {
			instanceId: this.instanceId
		});
	}

	/**
	 * @param {Object} options
	 * @param {string} options.baseClass
	 * @param {string} [options.modifierClass]
	 * @param {Object} options.view
	 */
	create({ baseClass, modifierClass, view }) {
		this.className = baseClass;
		const cssClass = modifierClass !== undefined ? modifierClass : 'o-overlay-modal--default';
		const templates = new Templates();

		this.container = document.createElement('div');
		this.container.classList.add('o-overlay-modal');
		this.container.classList.add(cssClass);
		this.container.innerHTML = templates.modal({ baseClass, view });

		this.setup();

		return this.container;
	}

	eventListerners() {
		this.dom.close.addEventListener('click', this.closeEvent, false);
	}

	initDomCache() {
		this.dom = {};

		const elements = [
			...this.container.querySelectorAll('[data-ref^=' + this.className + ']')
		];

		log('InitDomCache elements:', elements);

		for (let a = 0; a < elements.length; a++) {
			const element = elements[a];
			const ref = element.getAttribute('data-ref');
			const key = dashCaseToCamelCase(ref).split('__')[1];

			if (key) {
				this.dom[key] = element;
			} else {
				// eslint-disable-next-line no-console
				console.error('DOM element cannot be correctly cached, have you used the correct pattern? Reference "' + ref + '" is expected to have the format "behavior-name__element-name"');
			}
		}
	}

	setup() {
		this.initDomCache();
		this.eventListerners();
	}
}

export default Modal;
